import { Divider, Tooltip } from 'antd'
import React from 'react'
import { FormattedHTMLMessage, FormattedMessage, useIntl } from 'react-intl'
import { StickerCategory, Sticker } from '../../../types'
import anwerStickerObject from '../../../asset/anwerStickerObject'
import ctgNameData from '../../../data/ctgNameData'
import { emotionDescription } from '../../../data/emotionsTagDescription'
import getEmoticonDescription from '../../../utils/getEmoticonDescription'
import { refuseMock } from '../../../data/refuseExample'
import getRefusedSticker from '../../../utils/getRefusedSticker'
import { getEmojinameByIcon } from '../../../utils/findEmoji'

const getKeytoken = (d: string): 'keytokenEn' | 'keytokenKo' => {
  if (d === 'ko') {
    return 'keytokenKo'
  }
  return 'keytokenEn'
}

export default function SelectTagConfirm({
  selectedSticker,
  selectedEmojiCategory,
}: {
  selectedSticker: Sticker
  selectedEmojiCategory: StickerCategory
}) {
  const intl = useIntl()
  const answerSticker = anwerStickerObject[selectedEmojiCategory.icon as string]
  const selectedEmojiCategoryName =
    intl.locale === 'ko'
      ? ctgNameData.find((el) => el.emoji === selectedEmojiCategory.icon)
          ?.name_ko
      : selectedEmojiCategory.name
  return (
    <div>
      <div style={{ display: 'flex', margin: '22px 32px 0px 32px' }}>
        <img
          style={{ height: '16px', width: '16px' }}
          src={
            require('../../../img/upload/upload-tag-verification.png').default
          }
          alt="upload tag verification"
        ></img>
        <div className="answer-sticker-modal-title">
          <FormattedMessage id="SelectTag.modal.answerSticker.title" />
        </div>
      </div>
      <div
        style={{
          marginRight: '32px',
          marginLeft: '32px',
          marginTop: '8px',
        }}
      >
        <div className="answer-sticker-modal-description">
          <FormattedHTMLMessage id="SelectTag.modal.answerSticker.description" />
        </div>
      </div>
      <div style={{ marginRight: '32px', marginLeft: '32px' }}>
        <Divider />
      </div>
      <div
        style={{
          display: 'flex',
          marginLeft: '32px',
          marginRight: '32px',
        }}
      >
        <div
          className="answer-sticker-modal-content-div"
          style={{ marginRight: '12.5px' }}
        >
          <div className="answer-sticker-modal-selected-tag">
            <FormattedMessage
              id="SelectTag.modal.answerSticker.selectedSticker"
              defaultMessage="Selected Sticker"
            />
          </div>
          <div style={{ marginTop: '8px' }}>
            <img
              src={selectedSticker.origin}
              width={240}
              height={240}
              style={{ border: '1px solid #ddd', borderRadius: 5 }}
              alt="sticker_image"
            />
          </div>
        </div>
        {/* 선택한 태그 */}
        <div style={{ width: 275 }}>
          <div
            className="answer-sticker-modal-content-div"
            style={{ marginLeft: '12.5px' }}
          >
            <div className="answer-sticker-modal-selected-tag">
              <FormattedMessage id="SelectTag.modal.answerSticker.selectedTag" />
            </div>
            <div style={{ marginTop: '8px' }}>
              <div className="answer-sticker-modal-tag-box">
                <div
                  style={{
                    marginRight: '22px',
                    fontSize: '28px',
                  }}
                >
                  {selectedEmojiCategory.icon}
                </div>
                <div className="answer-sticker-modal-tag">
                  {selectedEmojiCategoryName}
                </div>
              </div>
            </div>
            <div>
              <div className="answer-sticker-modal-selected-tag-description">
                <FormattedMessage id="SelectTag.modal.answerSticker.select.description"></FormattedMessage>
              </div>
              <div className="answer-sticker-modal-tag-box-under">
                <ul className="tag-description-modal">
                  {getEmoticonDescription(
                    selectedEmojiCategory.icon,
                    intl.locale,
                  ).map((des: string) => {
                    return <li key={des}>{des}</li>
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="answer-sticker-modal-answer-sticker-div">
        <div className="answer-sticker-modal-selected-tag">
          <FormattedMessage id="SelectTag.modal.answerSticker.selectedAnswerStickers" />
        </div>
        <div className="answer-sticker-modal-sticker-img-box">
          {answerSticker.map((stickerURL: string, i: number) => {
            return (
              <img
                style={{
                  width: '91px',
                  height: '91px',
                  border: '1px solid #ddd',
                  borderRadius: 5,
                }}
                key={i}
                src={stickerURL}
                alt="answerStickerList"
              ></img>
            )
          })}
        </div>
        {/* 반려 예시 */}
        {refuseMock[selectedEmojiCategory.icon] && (
          <div>
            <div className="refuse-sticker-text">
              <FormattedMessage id="SeleteTag.modal.RefuseSticker"></FormattedMessage>
            </div>
            <div className="refuse-sticker-text-explain">
              <FormattedMessage id="SeleteTag.modal.RefuseSticker.explain"></FormattedMessage>
            </div>
            <div className="answer-sticker-modal-sticker-img-box">
              {refuseMock[selectedEmojiCategory.icon].map((refuseStkInfo) => {
                return (
                  <div key={refuseStkInfo.imgLink}>
                    <img
                      style={{
                        width: '91px',
                        height: '91px',
                        border: '1px solid #ddd',
                        borderRadius: 5,
                      }}
                      key={refuseStkInfo.imgLink}
                      src={refuseStkInfo.imgLink}
                      alt="answerStickerList"
                    ></img>
                    <div className="realTag-refused-sticker">
                      {refuseStkInfo.imgTag.map((realTag: string) => {
                        return (
                          <Tooltip
                            key={realTag}
                            placement="bottom"
                            title={
                              intl.locale === 'ko'
                                ? getEmojinameByIcon(realTag)?.name_ko
                                : getEmojinameByIcon(realTag)?.name_en
                            }
                          >
                            {realTag}
                          </Tooltip>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
